module.exports = __webpack_public_path__ + "static/awards-04-42821843464c7256f3c98111221673b8.png";